export default __webpack_public_path__ + "static/media/chef_t_sad.0bca6bdd.svg";